import { computed } from 'vue';
import { useQueryV2 } from '@libs/use';
import { OrderItem, OrderPosition } from '@libs/api-reference';

import * as API from '../requests';
import { ORDERS_QUERY_KEYS } from '../constants';

function orderPositionFactory(order: OrderItem) {
  return {
    isin: order?.instrumentIdentification,
    queryParams: {
      orderSide: order?.orderSideId,
      exchangeCode: order?.exchangeCode,
      orderSequenceNumber: order?.hostOrderNumber,
      entryDate: order?.entryDate,
    },
  };
}

export default function useGetOrderPosition(order: OrderItem) {
  const {
    result,
    execute: getOrderPosition,
    isPending: isLoadingOrderPosition,
    isError: isErrorGettingOrderPosition,
    isSuccess: isSuccessGettingOrderPosition,
    ...query
  } = useQueryV2<OrderPosition>(
    () => API.getOrderPosition(orderPositionFactory(order)),
    {
      key: ORDERS_QUERY_KEYS.orderPosition(order.orderId),
    }
  );

  const orderPositionInfo = computed(() => result.value?.data);

  return {
    orderPositionInfo,
    getOrderPosition,
    isLoadingOrderPosition,
    isErrorGettingOrderPosition,
    isSuccessGettingOrderPosition,
    ...query,
  };
}
